import { FC, ReactNode } from "react";
import { View, StyleSheet } from "@react-pdf/renderer";

type Props = {
  children: ReactNode;
};

const styles = StyleSheet.create({
  wrapper: {
    // former "side"
    flexBasis: "50%",
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
  },
  card: {
    // former "sideBlock"
    border: "1px solid #C1CFD4",
    width: "100%",
    flexBasis: "100%",
    borderRadius: 8,
    padding: 12,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    rowGap: 32,
    alignItems: "flex-start",
  },
});

export const Card: FC<Props> = ({ children }) => {
  return (
    <View style={styles.wrapper}>
      <View style={styles.card}>{children}</View>
    </View>
  );
};
